import {
    GET_SLACK_EVENT,
    FETCH_SLACK_EVENT,
    EDIT_SLACK_EVENT,
    ADD_SLACK_EVENT,
    DELETE_SLACK_EVENT,
    CLEAR_SLACK_EVENT,
    CLEAR_ALL,
    PENDING_SLACK_EVENT,
    SLACK_EVENT_PAGE,
    CLEAR_SLACK_EVENT_UPDATES,
  } from "../constants/actions";
  
  const initialState = {
    slack_events: [],
    pending: false,
    pageNumber: 1,
    created: false,
    updated: false,
  };
  
  export default function slackEvent(state = initialState, action) {
    switch (action.type) {
      case PENDING_SLACK_EVENT:
        return {
          ...state,
          pending: true,
        };
      case GET_SLACK_EVENT:
        return {
          ...state,
          slack_events: action.payload,
          pending: false,
        };
      case SLACK_EVENT_PAGE:
        return {
          ...state,
          pageNumber: action.payload,
        };
      case FETCH_SLACK_EVENT:
        return {
          ...state,
          [action.payload.id]: action.payload,
          pending: false,
        };
      case EDIT_SLACK_EVENT:
        return {
          ...state,
          [action.payload.id]: action.payload,
          pending: false,
        };
      case ADD_SLACK_EVENT:
        return {
          ...state,
          created: action.payload,
          updated: Math.random(),
          pending: false,
        };
      case DELETE_SLACK_EVENT:
        return {
          ...state,
          updated: Math.random(),
          pending: false,
        };
      case CLEAR_SLACK_EVENT_UPDATES:
        return {
          ...state,
          updated: false,
          created: false,
        };
      case CLEAR_SLACK_EVENT:
        return {
          ...state,
          ...initialState,
        };
      case CLEAR_ALL:
        return initialState;
      default:
        return state;
    }
  }